import { apiFetch, formatApiErrorDetail } from "../../lib/auth";

export async function agencyApi(path, body, method = body === undefined ? "GET" : "POST") {
  const r = await apiFetch(`/api/agency${path}`, { method, body: body === undefined ? undefined : JSON.stringify(body) });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(formatApiErrorDetail(data.detail));
  return data;
}

export const inr = (minor) => `₹${((minor || 0) / 100).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
export const fmtD = (s, opts = { day: "numeric", month: "short" }) => (s ? new Date(`${String(s).slice(0, 10)}T00:00:00`).toLocaleDateString("en-GB", opts) : "—");
export const input = "h-11 w-full rounded-xl border border-separator bg-white px-3.5 text-sm outline-none focus:border-tint focus:shadow-[0_0_0_4px_rgba(0,136,255,0.12)]";
export const TONE = { approved: "success", refused: "danger", in_review: "warning", filed: "success" };
export const INV_TONE = { paid: "success", partially_paid: "warning", sent: "tint", overdue: "danger", cancelled: "neutral", draft: "neutral" };
